module.exports = __webpack_public_path__ + "img/use-app-3.111265c6.jpg";